import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/renovation-works2.jpg';
import { Helmet } from 'react-helmet';

const Renovationwork = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (

         <>
      <Helmet>
        <title>Renovation Works</title>
        <meta name="description" content="Give Your Old Space a Fresh New Life" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">

                 <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>

                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1> Renovation Works </h1>
                                <h6>Give Your Old Space a Fresh New Life</h6>
                                <p>
                            Whether it's a home or office, YATRI INTERIORS offers comprehensive 
                            renovation services to reimagine your existing space into something truly special.
                                </p>
                                <h4>Our renovation package includes :</h4>
                                <ul>
                                    <li>Structural & design modifications</li>
                                    <li>Interior redesign and furnishing</li>
                                    <li>Plumbing, electrical rewiring</li>
                                    <li>New paint & polish</li>
                                    <li>Fixture upgrades and more</li>
                                    <p>Get expert consultation and a new-age makeover — without the stress.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>


                   
                    
                
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Renovationwork ;